import { compose } from 'redux';
import { connect } from 'react-redux';

import SortableList from './component';

const mapStateToProps = null;
const mapDispatchToProps = null;

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(SortableList);
